import { Instance } from 'mobx-state-tree';
import { PharmacyStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { User } from '../../../store/models/User';

interface UserFormFieldProps extends WithTranslateProps {
  UserStore?: Instance<typeof PharmacyStore>;
  userList?: Array<Instance<typeof User>>;
}

@inject('UserStore')
@observer
class UserFormField extends React.Component<UserFormFieldProps> {
  renderUserMenuItem(item: Instance<typeof User>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`user-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.firstName + ' ' + item.lastName!}
        />
      );
    } else {
      return null;
    }
  }

  filterUser = (query, user) => {
    return (user.firstName!.toLowerCase() + ' ' + user.lastName!.toLowerCase()).indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { userList, UserStore, ...otherProps } = this.props;

    return (
      <SelectInputFormField
        label={TLCode.USER}
        name="userId"
        inline={true}
        items={toJS(userList)}
        itemValueGetter={(item: any) => item.userId}
        valueItemGetter={(value) => UserStore!.getById(value)!}
        inputValueRenderer={(item) => (item != null ? item.firstName + ' ' + item.lastName! : '')}
        itemRenderer={this.renderUserMenuItem}
        itemPredicate={this.filterUser}
        // allowEmpty={true}
        identifier={'userId'}
        elementLabel={'lastName'}
        labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_USER)}
        helperText={this.props.translate(TLCode.CHOOSE_A_USER)}
        placeholderSelection={TLCode.CHOOSE_A_USER}
        {...otherProps}
      />
    );
  }
}

export default withTranslate(UserFormField);
